import { Component } from 'react';
import SakuraOrbit from './SakuraOrbit';
import PageMeta from './PageMeta';
import { Link } from 'react-router-dom';
import { DataRPC } from '../../rpc-client/DataRPC';
import { s3 } from '../../config/constants';
import SakuraSep from './SakuraSep';

const rpc = new DataRPC();

/* ── Helpers ──────────────────────────────────────────────── */
const fmt = (n) => Number(n).toLocaleString('vi-VN') + ' ₫';

const FORM_FIELDS = [
    { name: 'name',    label: 'Họ và tên *',         type: 'text',  placeholder: 'Nguyễn Văn A',                     multiline: false },
    { name: 'email',   label: 'Email *',              type: 'email', placeholder: 'email@example.com',               multiline: false },
    { name: 'phone',   label: 'Số điện thoại *',      type: 'tel',   placeholder: '0912 345 678',                    multiline: false },
    { name: 'address', label: 'Địa chỉ giao hàng *', type: 'text',  placeholder: '123 Đường ABC, Quận X, TP. HCM',  multiline: false },
    { name: 'note',    label: 'Ghi chú',              type: 'text',  placeholder: 'Giao giờ hành chính, để trước cửa…', multiline: true },
];

/* ── Component ────────────────────────────────────────────── */
class Products extends Component {
    state = {
        products:    [],
        loading:     true,
        quantities:  {},
        cart:        [],
        cartOpen:    false,
        checkout:    false,
        submitted:   false,
        submitting:  false,
        added:       null,
        form:        { name: '', email: '', phone: '', address: '', note: '' },
        formError:   '',
    };

    componentDidMount() {
        rpc.fetchRawData('GetProducts', { page: 1, limit: 100 })
            .then(res => {
                const products = (res?.data ?? []).map(p => ({
                    ...p,
                    price: parseFloat(p.price) || 0,
                    img:   s3(p.avatar_url),
                    desc:  p.description,
                    badge: null,
                }));
                this.setState({ products, loading: false });
            })
            .catch(() => this.setState({ loading: false }));
    }

    /* qty helpers */
    getQty = (id) => this.state.quantities[id] ?? 1;

    setQty = (id, raw) => {
        const n = Math.max(1, Math.min(99, parseInt(raw, 10) || 1));
        this.setState(prev => ({ quantities: { ...prev.quantities, [id]: n } }));
    };

    /* cart actions */
    addToCart = (product) => {
        const qty = this.getQty(product.id);
        this.setState(prev => {
            const existing = prev.cart.find(c => c.id === product.id);
            const cart = existing
                ? prev.cart.map(c => c.id === product.id ? { ...c, qty: c.qty + qty } : c)
                : [...prev.cart, { ...product, qty }];
            return { cart, quantities: { ...prev.quantities, [product.id]: 1 }, added: product.id };
        }, () => setTimeout(() => this.setState({ added: null }), 1300));
    };

    removeFromCart = (id) => {
        this.setState(prev => ({ cart: prev.cart.filter(c => c.id !== id) }));
    };

    changeCartQty = (id, delta) => {
        this.setState(prev => ({
            cart: prev.cart.map(c =>
                c.id === id ? { ...c, qty: Math.max(1, c.qty + delta) } : c
            ),
        }));
    };

    /* checkout form */
    handleField = (e) => {
        const { name, value } = e.target;
        this.setState(prev => ({ form: { ...prev.form, [name]: value } }));
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const { form, cart } = this.state;
        if (!form.name.trim() || !form.email.trim() || !form.phone.trim() || !form.address.trim()) {
            this.setState({ formError: 'Vui lòng điền đầy đủ các thông tin bắt buộc (*).' });
            return;
        }
        this.setState({ submitting: true, formError: '' });
        try {
            await Promise.all(cart.map(item =>
                rpc.fetchRawData('InsertOrder', {
                    product_id:       item.id,
                    quantity:         item.qty,
                    customer_name:    form.name.trim(),
                    customer_email:   form.email.trim(),
                    customer_phone:   form.phone.trim(),
                    customer_address: form.address.trim(),
                    customer_note:    form.note.trim() || null,
                })
            ));
            this.setState({ submitted: true, submitting: false });
        } catch (err) {
            this.setState({ submitting: false, formError: 'Đặt hàng thất bại, vui lòng thử lại.' });
        }
    };

    resetAfterOrder = () => {
        this.setState({
            cart: [], cartOpen: false, checkout: false, submitted: false,
            form: { name: '', email: '', phone: '', address: '', note: '' },
        });
    };

    render() {
        const { products, loading, cart, cartOpen, checkout, submitted, submitting, added, form, formError } = this.state;
        const cartCount = cart.reduce((s, c) => s + c.qty, 0);
        const total     = cart.reduce((s, c) => s + c.price * c.qty, 0);

        return (
            <div className="products-page">
                <PageMeta title="Gút-zự" description="Sản phẩm lưu niệm của Vietnam Yosakoi Festival – áo, phụ kiện và nhiều hơn nữa." url="/products" />

                {/* Page header */}
                <div className="page-header products-page-header">
                    <div className="page-header-overlay" />
                    <div className="container page-header-body">
                        <div className="row">
                            <div className="col-12">
                                <div className="entry-meta-date">Việt Nam Yosakoi Festival</div>
                                <h1 className="page-header-title">CỬA HÀNG</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="sep-gold-rule" style={{margin: 0}} />

                {/* Products grid */}
                <div className="products-section">
                    <div className="container">
                        <div className="entry-title">
                            <p>CHUYÊN SỈ LẺ HÀNG YOSAKOI</p>
                            <h2>CÁC SẢN PHẨM YOSAKOI</h2>
                        </div>

                        {loading && <SakuraOrbit label="Đang tải sản phẩm" />}
                        <div className="ppg-grid">
                            {products.map(p => {
                                const isAdded = added === p.id;
                                return (
                                    <div key={p.id} className="ppg-card">
                                        <div className="ppg-img-wrap">
                                            <img src={p.img} alt={p.name} />
                                            <div className="ppg-img-overlay" />
                                            {p.badge && <span className="ppg-badge">{p.badge}</span>}
                                        </div>
                                        <div className="ppg-body">
                                            <span className="ppg-category">{p.category}</span>
                                            <h3 className="ppg-name">{p.name}</h3>
                                            <p className="ppg-desc">{p.desc}</p>
                                            <div className="ppg-price">{fmt(p.price)}</div>
                                            <div className="ppg-actions">
                                                <div className="ppg-qty-wrap">
                                                    <button className="ppg-qty-btn" onClick={() => this.setQty(p.id, this.getQty(p.id) - 1)}>−</button>
                                                    <input
                                                        className="ppg-qty-input"
                                                        type="number"
                                                        min="1" max="99"
                                                        value={this.getQty(p.id)}
                                                        onChange={e => this.setQty(p.id, e.target.value)}
                                                    />
                                                    <button className="ppg-qty-btn" onClick={() => this.setQty(p.id, this.getQty(p.id) + 1)}>+</button>
                                                </div>
                                                <button
                                                    className={`ppg-add-btn${isAdded ? ' ppg-added' : ''}`}
                                                    onClick={() => this.addToCart(p)}
                                                >
                                                    {isAdded
                                                        ? <><span>✓</span> Đã thêm</>
                                                        : 'Thêm vào giỏ'
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {/* Cart added toast */}
                {added !== null && (
                    <div className="cart-fab-toast" onClick={() => this.setState({ cartOpen: true, checkout: false })}>
                        Hàng đã dzô giỏ!&nbsp;<span className="cart-fab-toast-cta">Xem ngay →</span>
                    </div>
                )}

                {/* Floating cart button */}
                <button
                    className={`cart-fab${cartCount > 0 ? ' cart-fab-active' : ''}${added !== null ? ' cart-fab-jolt' : ''}`}
                    onClick={() => this.setState({ cartOpen: true, checkout: false })}
                    aria-label="Giỏ hàng"
                >
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                        <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {cartCount > 0 && <span className="cart-fab-badge">{cartCount}</span>}
                </button>

                {/* Backdrop */}
                <div
                    className={`cart-overlay${cartOpen ? ' cart-overlay-show' : ''}`}
                    onClick={() => this.setState({ cartOpen: false })}
                />

                {/* Drawer */}
                <div className={`cart-drawer${cartOpen ? ' cart-drawer-open' : ''}`}>

                    {submitted ? (
                        /* ── Success ─────────────────────── */
                        <div className="cart-success">
                            <div className="cart-success-kanji">桜</div>
                            <h3>Đặt Hàng Thành Công!</h3>
                            <p>Cảm ơn bạn đã đặt hàng. Chúng tôi sẽ liên hệ xác nhận qua email và số điện thoại trong vòng 24 giờ.</p>
                            <button className="btn-drawer-continue" onClick={this.resetAfterOrder}>
                                Tiếp Tục Mua Sắm
                            </button>
                        </div>

                    ) : !checkout ? (
                        /* ── Cart view ───────────────────── */
                        <>
                            <div className="cart-drawer-header">
                                <h3 className="cart-drawer-title">
                                    Giỏ Hàng
                                    {cartCount > 0 && <span className="cart-count-chip">{cartCount}</span>}
                                </h3>
                                <button className="cart-close-btn" onClick={() => this.setState({ cartOpen: false })}>✕</button>
                            </div>

                            {cart.length === 0 ? (
                                <div className="cart-empty">
                                    <div className="cart-empty-icon">🛍</div>
                                    <p>Giỏ hàng đang trống, kiếm vài gút ném vào đi các chế</p>
                                    <button className="btn-drawer-continue" onClick={() => this.setState({ cartOpen: false })}>
                                        Tiếp Tục Mua Sắm
                                    </button>
                                </div>
                            ) : (
                                <>
                                    <div className="cart-items-list">
                                        {cart.map(item => (
                                            <div key={item.id} className="cart-item">
                                                <img src={item.img} alt={item.name} className="cart-item-img" />
                                                <div className="cart-item-body">
                                                    <div className="cart-item-name">{item.name}</div>
                                                    <div className="cart-item-unit">{fmt(item.price)}</div>
                                                    <div className="cart-item-qty-ctrl">
                                                        <button onClick={() => this.changeCartQty(item.id, -1)}>−</button>
                                                        <span>{item.qty}</span>
                                                        <button onClick={() => this.changeCartQty(item.id, 1)}>+</button>
                                                    </div>
                                                </div>
                                                <div className="cart-item-end">
                                                    <button className="cart-item-del" onClick={() => this.removeFromCart(item.id)} aria-label="Xóa">✕</button>
                                                    <div className="cart-item-subtotal">{fmt(item.price * item.qty)}</div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="cart-footer">
                                        <div className="cart-total-row">
                                            <span>Tổng cộng</span>
                                            <span className="cart-grand-total">{fmt(total)}</span>
                                        </div>
                                        <p className="cart-ship-note">Phí vận chuyển sẽ được xác nhận khi đặt hàng.</p>
                                        <button className="btn-to-checkout" onClick={() => this.setState({ checkout: true })}>
                                            Thanh Toán
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                                <polyline points="9 18 15 12 9 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </button>
                                    </div>
                                </>
                            )}
                        </>

                    ) : (
                        /* ── Checkout view ───────────────── */
                        <>
                            <div className="cart-drawer-header">
                                <button className="cart-back-btn" onClick={() => this.setState({ checkout: false })}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <polyline points="15 18 9 12 15 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    Giỏ hàng
                                </button>
                                <button className="cart-close-btn" onClick={() => this.setState({ cartOpen: false, checkout: false })}>✕</button>
                            </div>

                            <div className="co-scroll">
                                {/* Order summary */}
                                <div className="co-summary">
                                    <div className="co-summary-title">Đơn hàng của bạn</div>
                                    {cart.map(item => (
                                        <div key={item.id} className="co-summary-row">
                                            <span className="co-s-name">
                                                {item.name}
                                                <span className="co-s-qty"> × {item.qty}</span>
                                            </span>
                                            <span className="co-s-sub">{fmt(item.price * item.qty)}</span>
                                        </div>
                                    ))}
                                    <div className="co-summary-total">
                                        <span>Tổng đơn hàng</span>
                                        <span className="co-total-price">{fmt(total)}</span>
                                    </div>
                                </div>

                                {/* Contact form */}
                                <form className="co-form" onSubmit={this.handleSubmit} noValidate>
                                    <div className="co-form-title">Thông Tin Nhận Hàng</div>
                                    {FORM_FIELDS.map(f => (
                                        <div key={f.name} className="co-field">
                                            <label className="co-label">{f.label}</label>
                                            {f.multiline ? (
                                                <textarea
                                                    className="co-input co-textarea"
                                                    name={f.name}
                                                    placeholder={f.placeholder}
                                                    value={form[f.name]}
                                                    onChange={this.handleField}
                                                    rows={3}
                                                />
                                            ) : (
                                                <input
                                                    className="co-input"
                                                    type={f.type}
                                                    name={f.name}
                                                    placeholder={f.placeholder}
                                                    value={form[f.name]}
                                                    onChange={this.handleField}
                                                />
                                            )}
                                        </div>
                                    ))}
                                    {formError && <p className="co-error">{formError}</p>}
                                    <button type="submit" className="btn-place-order" disabled={submitting}>
                                        {submitting ? 'Đang xử lý…' : 'Đặt Hàng Ngay'}
                                        {!submitting && (
                                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                                                <polyline points="9 18 15 12 9 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        )}
                                    </button>
                                </form>
                            </div>
                        </>
                    )}

                </div>

                <SakuraSep />
                <div className="sep-gold-rule" style={{margin: 0}} />

            </div>
        );
    }
}

export default Products;
